import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const Loader = () => {
  return (
    <Box
      data-testid="loading-state"
      display="flex"
      justifyContent="center"
      alignItems="center"
      paddingTop="10rem"
    >
      <CircularProgress />
    </Box>
  );
};

export default Loader;
